import { Component, ViewEncapsulation } from '@angular/core';
import { CommonService } from "../../../shared/common/common.service";

@Component({
    selector: 'app-export-to-excel',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './export-to-excel.component.html'
})
export class ExportToExcelComponent {
    public excelUrl: string;
    public excelUrlshow: boolean;

    constructor(private commonService: CommonService) {        
        this.commonService.excelExportUrl
            .subscribe((value: any) => {
                this.excelUrlshow = value.flag;
                this.excelUrl = value.url;
            });
    }    
}



// WEBPACK FOOTER //
// ./src/app/core/components/export-to-excel/export-to-excel.component.ts